import styled from 'styled-components';
import { Input } from 'components/atoms';

const StyledInput = styled(Input)`
  padding: 0 0 0 10px !important;
  height: calc(1.75em + 0.5rem + 2px);
  border-radius: 0 !important;
`;

export default StyledInput;
